<!-- Refund Payment Modal -->
<div class="modal fade" id="refundPaymentModal" msEscClose
	(escPressed)="onCancel()"
	data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
	aria-labelledby="refundPaymentModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-lg">
		<div class="modal-content">

			<div class="modal-body text-center">
				<fa-duotone-icon icon="circle-question" class="confirmation-icon text-info" />

				<div class="pt-4 px-4">{{ confirmationMessage }}</div>

				<form [formGroup]="refundForm" (keydown.enter)="$event.preventDefault()" class="px-4 py-0 text-start">

					<!-- Payable Account (required) -->
					<ms-input-label
						[labelText]="'Payable Account'"
						[isRequired]="isFieldRequired(refundForm, 'payableChartOfAccount')"
						class="mt-3" />
					<ms-chart-of-account-typeahead
						formControlName="payableChartOfAccount"
						[organizationId]="organizationId()"
						[categories]="[ChartOfAccountCategory.Liabilities]"
						[invalid]="refundForm.get('payableChartOfAccount')?.invalid && refundForm.get('payableChartOfAccount')?.touched ? true : false"
						placeholder="Search by account name..." />
					@if (refundForm.get('payableChartOfAccount')?.errors?.['required'] && refundForm.get('payableChartOfAccount')?.touched) {
						<div class="error-messages">
							<p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.RefundPaymentPayableAccountRequired }}</p>
						</div>
					}

					<!-- Notes (optional) -->
					<ms-input-label [labelText]="'Notes'" class="mt-3" />
					<textarea
						id="refundPaymentNote"
						formControlName="note"
						maxlength="255"
						rows="3"
						class="form-control"
						[class.is-invalid]="refundForm.get('note')?.invalid && refundForm.get('note')?.touched"
						[class.is-valid]="refundForm.get('note')?.valid && refundForm.get('note')?.touched && refundForm.get('note')?.value !== ''">
					</textarea>
					@if (refundForm.get('note')?.errors?.['maxlength'] && refundForm.get('note')?.touched) {
						<div class="error-messages">
							<p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.NoteMaxLength }}</p>
						</div>
					}
				</form>
			</div>

			<div class="modal-footer border-0 d-flex justify-content-center pb-4">
				<button type="button" class="btn btn-ms-secondary" (click)="onCancel()" [disabled]="isSubmitting">
					Cancel
				</button>
				<button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="isSubmitting">
					@if (isSubmitting) {
						<div class="spinner-border text-light spinner-border-sm" role="status">
							<span class="visually-hidden">Loading...</span>
						</div>
					} @else {
						Refund
					}
				</button>
			</div>

		</div>
	</div>
</div>

<!-- Info Modal -->
<ms-info-modal #refundPaymentInfoRef modalId="refundPaymentInfoModal"
	(onConfirm)="infoModalConfirmed()" />

<!-- Esc Confirmation Modal -->
<ms-confirmation-modal
	#refundPaymentEscConfirmationRef
	modalId="refundPaymentEscConfirmationModal"
	confirmButtonText="Leave"
	cancelButtonText="Stay"
	(confirmed)="onEscConfirmed()"
	(cancelled)="onEscCancelled()"
/>
